export enum RoleIds {
  manager = 1,
  compiler = 2,
  factchecker = 3,
  writer = 4,
  financialAdmin = 5,
  warfareCompiler = 6,
  triviaMaticManager = 7,
}
